<button class="btn-content" mat-flat-button="" (click)="openModal()">
  {{"Upload Files" | translate}}
</button>
